var $d612b270ee5ea6ca$exports = {};
$d612b270ee5ea6ca$exports = {
    "Empty": `\u{418}\u{437}\u{43F}\u{440}\u{430}\u{437}\u{43D}\u{438}`
};


export {$d612b270ee5ea6ca$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
